import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';
import {listToReadable} from 'util/NameUtil';

export interface FilesPickerProps {
  isDisabled?: boolean;
  multiple: boolean;
  fileTypes?: Array<string>;
}

function FilesPicker({isDisabled, multiple, fileTypes}: FilesPickerProps): JSX.Element {
  return (
    <>
      <input
        disabled={isDisabled}
        type="file"
        multiple={multiple}
        accept={fileTypes?.join(',')}
        className="hidden file"
        data-test-component="FilesPicker"
        data-test-element="input"
      />
      <div className={classNames('drop-help', css(styles.filePickerDropHelp))}>
        <span className="glyphicon glyphicon-cloud-upload" />
        <span className="instructions">Drag and drop to upload or</span>
        <Button
          disabled={isDisabled}
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          className="file-choose u-mini-spacing-left"
          size={ButtonSize.SMALL}
          text={multiple ? 'Choose files' : 'Choose a file'}
        />
      </div>
      {fileTypes && (
        <div className={css(styles.fileTypes)}>
          Supported file type{fileTypes.length > 1 ? 's are ' : ' is '}
          {listToReadable(fileTypes)}
        </div>
      )}
      <h5 className="js-files-title hidden">
        {multiple ? 'Files to Upload' : 'File to Upload'} (<span className="js-files-count" />)
      </h5>
      <div className="files-list-wrapper">
        <table className="table table-bordered">
          <tbody className="files-list" />
        </table>
      </div>
    </>
  );
}

const styles = StyleSheet.create({
  filePickerDropHelp: {
    marginRight: '0px',
    marginLeft: '0px',
    marginBottom: '8px',
  },
  fileTypes: {
    marginBottom: '16px',
    fontSize: '16px',
  },
});

export default makeDeprecatedJadeStyleTemplate<FilesPickerProps>(FilesPicker);
